import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { BaseRepository } from 'src/app/services/remote-data-service/repositories/base.repository';
import { TagMapper } from 'src/app/services/remote-data-service/mappers/tag.mapper';
import { TagDto } from 'src/app/services/remote-data-service/dtos/tag.dto';
import { Tag } from 'src/app/entities/tag/tag';
import { catchError, map } from 'rxjs';
import log from 'loglevel';
import { SnackbarService } from 'src/app/services/snackbar-service/snackbar.service';


/**
 * GraphQL arguments for `get_time-track_tags` query.
 */
export interface TimeTrackTagsFilters {
  page?: number;
  limit?: number;
  name?: string;
}


@Injectable({
  providedIn: 'root',
})
export class TagRepository extends BaseRepository<Tag, TagDto> {
  protected override _mapper = new TagMapper();
  protected override dataPropertyName = 'get_time_track_tags';

  protected override logger = log.getLogger('TagRepository');

  constructor(
    protected override apollo: Apollo,
    protected override snackBar: SnackbarService
  ) {
    super(apollo, snackBar);
  }

  /******************/
  /* Public methods */
  /******************/
  public override getGqlQuery() {
    return gql`
      query TagsQuery($page: Int, $limit: Int, $name: String) {
        get_time_track_tags (page: $page, limit: $limit, name: $name) {
          items {
            name
            uuid
            permissions {
              update
              delete
            }
          }
          total
          pager {
              current
              next
              prev
          }
        }
      }
    `;
  }


  /**
   * Function to add new tags
   * @param tag
   * @returns A boolean observable that indicated if query was successful.
   */
  public addNewTag(tag: Tag) {
    const ADDTAG = gql`
      mutation createTimeTrackTag {
        create_time_track_tag(data: {
          uuid: "${tag.id}",
          name: "${tag.label}"
        }) {
          time_track_tag {
            uuid
            name
            permissions {
              update
              delete
            }
          }
        }
      }
    `;

    return this.apollo
      .mutate({
        mutation: ADDTAG,
        variables: {},
      })
      .pipe(
        map(() => true),
        catchError((error) => {
          this.logger.error(error);
          this.snackBar.showError(error);
          return [];
        })
      );
  }


  /**
   * Function to update a tags data.
   * @param tag
   * @returns A boolean observable that indicated if query was successful.
   */
  public updateTag(tag: Tag) {
    const UPDATETAG = gql`
      mutation MyMutation {
        update_time_track_tag(
          uuid: "${tag.id}",
          data: {name: "${tag.label}"}
        ) {
          time_track_tag {
            uuid
            name
            permissions {
              update
              delete
            }
          }
          errors
        }
      }
    `;

    return this.apollo
      .mutate({
        mutation: UPDATETAG,
        variables: {},
      })
      .pipe(
        map(() => true),
        catchError((error) => {
          this.logger.error(error);
          this.snackBar.showError(error);
          return [];
        })
      );
  }


  /**
   * Function to delete a tags.
   * @param tag
   * @returns A boolean observable that indicated if query was successful.
   */
  public removeTag(tag: Tag) {
    const REMOVETAG = gql`
      mutation MyMutation {
        delete_time_track_tag(uuid: "${tag.id}") {
          time_track_tag {
            name
          }
          errors
        }
      }
    `;

    return this.apollo
      .mutate({
        mutation: REMOVETAG,
        variables: {},
      })
      .pipe(
        map(() => true),
        catchError((error) => {
          this.logger.error(error);
          this.snackBar.showError(error);
          return [];
        })
      );
  }
}
